import React from "react";
import Card from "../../Card";
import { useNavigate } from "react-router-dom";
import imgDetails5 from "../../../assets/Image/Details5/Photo1.jpg";

const AlreadySale = () => {
    const navigate = useNavigate();

    const handleCardClick = (id) => {
        navigate(`/details/${id}`);
    };

    return (
        <div className="flex flex-col my-24 mx-auto px-48 border xl:px-12 lg:px-10 md:px-8 sm:px-7">
            <h3 className="text-2xl mb-5 reveal-left">Historique</h3>
            <div className="flex flex-wrap justify-start gap-4 ml-10 reveal-right sm:ml-0">
                {/* <p className="font-light text-customGray2">
                    Aucun bien pour le moment ...
                </p> */}
                <Card
                    id="5"
                    price="900€"
                    status="Relouer"
                    img={imgDetails5}
                    title="Maison en location"
                    description="Maison 5 pièces"
                    adress="Bonneuils Matours"
                    onClick={() => handleCardClick(5)}
                />
            </div>
        </div>
    );
};

export default AlreadySale;
